<template>
  <div class="editQuotationWrapper">
    <div class="editQuotation">
      <div class="editQuotation__header">
        <!-- <div class="back" @click.stop="goToQuotationList()">
          <span class="back__icon strong"><i class="adx-ic_arrow_left"></i></span>
          <span class="back__all subhead color-pink">All Quotation</span>
        </div> -->
        <div class="title"><h1 class="medium-title">Edit Campaign</h1></div>
        <div class="title-2"><span class="subhead">Edit Detail Informations</span></div>
      </div>
      <div class="editQuotation__body">
        <div class="editQuotation__body__left">
          <div class="router-wrapper">
            <div class="title">
              <ul class="title__menu">
                <li class="subhead color-grey" :class="[isDetailInfo? 'router-link-active': '']" @click="selectedTab(1)">Summary</li>
                <li class="subhead color-grey" :class="[!isDetailInfo? 'router-link-active': '']" @click="selectedTab(2)">Channel Campaign</li>
              </ul>
            </div>
          </div>
          <div class="editQuotation__body__loading"  v-if="isLoadingMain">
            <adx-loading/>
          </div>
          <!-- display Information for CS -->
          <div v-if="!isLoadingMain && isDetailInfo">
            <template v-if="true">
              <div class="editQuotation__body__left__container">
                <h1 class="subhead title"> Campaign Quotation Name</h1>  
                <div class="editQuotation__body__left__container__item">
                  <adx-input :label="`Quotation Name`" :value.sync="model.quotationName" :inputId="`campaign_name`"
                    :error.sync="vuelidateOptions.quotationName.error" :ref="vuelidateOptions.quotationName.ref"/>
                </div>
              </div>
              <div v-if="isLoadingClient">
                <adx-loading/>
              </div>
              <div v-else class="editQuotation__body__left__container">
                <h1 class="subhead title"> Clients Information</h1>
                <div class="editQuotation__body__left__container__item">
                  <adx-single-search-dropdown :label="'Client Profile'" :value.sync="model.clientProfile.value"
                  :optionsParam="clientProfileList" @selected="changeClientProfile" :loading="isClientLoading"
                  :error.sync="vuelidateOptions.clientProfile.error" :ref="vuelidateOptions.clientProfile.ref"/>
                </div>
                <div class="quotationEditor__body__left__container__loading" v-if="loadingDetailClient">
                  <adx-loading/>
                </div>
                <div v-else>
                  <div class="editQuotation__body__left__container__item">
                    <adx-input :label="`Company Name`" :value.sync="clientProfile.companyName" :inputId="`company_name`"/>
                    <adx-input :label="`Brand`" :value.sync="clientProfile.brand" :inputId="`brand_name`"/>
                  </div>
                  <div class="editQuotation__body__left__container__item">
                    <adx-input :label="`Contact Person`" :value.sync="clientProfile.contactPerson" :inputId="`contact_name`"/>
                    <adx-input :label="`Email Address`" :value.sync="clientProfile.emailAdress" :inputId="`email_name`"/>
                  </div>
                  <div class="editQuotation__body__left__container__item">
                    <adx-input class="single-input" :label="`Phone Number`" :value.sync="clientProfile.phoneNumber"
                    :inputId="`phone_number`"/>
                  </div>
                </div>
                <div class="editQuotation__body__left__container__item">
                  <adx-textarea :label="`Quotation Note (Optional)`" :value.sync="model.note"/>
                </div>
                <div class="editQuotation__body__left__container__button">
                  <button class="btn-regular secondary update" @click="createOrUpdateClient('update')">
                    Update existing client
                  </button>
                  <button class="btn-regular primary create-new" @click="checkBrand('create')">
                    Save as New Client
                  </button>
                </div>
              </div>
            </template>
            <!-- display information for Commercial -->
            <template v-else>
              <div class="editQuotation__body__left__container">  
                <div class="editQuotation__body__left__container__item-2">
                  <div class="commercial__detail">
                    <div class="commercial__detail__label"><label class="mini-font color-grey bold">QUOTATION NAME</label></div>
                    <div class="commercial__detail__value-item"><label class="subhead ">{{model.quotationName}}</label></div>
                  </div>
                </div>
                <div class="editQuotation__body__left__container__item-2">
                  <div class="commercial__detail">
                    <div class="commercial__detail__label"><label class="mini-font color-grey bold">COMPANY NAME</label></div>
                    <div class="commercial__detail__value-item"><label class="subhead ">{{model.companyName}}</label></div>
                  </div>
                  <div class="commercial__detail">
                    <div class="commercial__detail__label"><label class="mini-font color-grey bold">BRAND</label></div>
                    <div class="commercial__detail__value-item"><label class="subhead ">{{model.brand}}</label></div>
                  </div>
                </div>
                <div class="editQuotation__body__left__container__item-2">
                  <div class="commercial__detail">
                    <div class="commercial__detail__label"><label class="mini-font color-grey bold">CONTACT PERSON</label></div>
                    <div class="commercial__detail__value-item"><label class="subhead ">{{model.contactPerson}}</label></div>
                  </div>
                  <div class="commercial__detail">
                    <div class="commercial__detail__label"><label class="mini-font color-grey bold">EMAIL ADDRESS</label></div>
                    <div class="commercial__detail__value-item"><label class="subhead ">{{model.emailAdress}}</label></div>
                  </div>
                </div>
                <div class="editQuotation__body__left__container__item-2">
                  <div class="commercial__detail">
                    <div class="commercial__detail__label"><label class="mini-font color-grey bold">PHONE NUMBER</label></div>
                    <div class="commercial__detail__value-item"><label class="subhead ">{{model.phoneNumber}}</label></div>
                  </div>
                </div>
                <div class="editQuotation__body__left__container__item-2">
                  <div class="commercial__detail">
                    <div class="commercial__detail__label"><label class="mini-font color-grey bold">QUOTATION NOTES</label></div>
                    <div class="commercial__detail__value-item"><label class="subhead ">{{model.note}}</label></div>
                  </div>
                </div>
              </div>
            </template>
            <!-- discussion section -->
            <!-- <div class="editQuotation__body__left__discussion">
              <h1 class="title">Internal Message</h1>
              <adx-discussions :list="discussionList" @submitComment="submitDiscussion"/>
            </div> -->
          </div>
        <div v-else>
          <div v-for="(campaign, index) in campaign_list" :key="index+`campaign_item`"  class="editQuotation__body__left__container">
            <div class="editQuotation__body__left__container__header">
              <div class="editQuotation__body__left__container__header__left">
              <span class="mini-font color-grey strong">CHANNEL CAMPAIGN</span>
              <div class="editQuotation__body__left__container__header__bottom">
                <h1 class="subhead title">{{campaign.name}}</h1>
                <div class="editQuotation__body__left__container__header__bottom__right">
                  <button class="secondary btn-small btn-left" @click="editCampaign(campaign.id)">Edit</button>
                  <button class="secondary btn-small btn-right" :disabled="campaign_list.length == 1" @click="removeCampaign(campaign.id, index)">Delete</button>
                </div>
              </div>
              </div>
              <div class="editQuotation__body__left__container__header__left">
                <h1 class="color-grey mini-font total-price ">TOTAL PRICE</h1>
                <label class="color-pink subhead strong">{{campaign.total_price | formatMoney}}</label>
              </div>
            </div>
            <div :key="`item_detail`">
              <div class="editQuotation__body__left__container__item-3" :key="media_itemsKey">
                <div v-for="(placement, idx) in campaign_medias[campaign.id].line_item_list" :key="idx" class="campaign-item">
                  <div class="campaign-item__left">
                    <span class="subhead strong">{{placement.line_item.name}}</span>
                    <span class="subhead">{{placement.line_item.location_data.name}}</span>
                  </div>
                  <div class="campaign-item__right">
                    <div class="campaign-item__right__price">
                      <span class="mini-font color-grey modal price-title">Price</span>
                      <span class="subhead color-pink">{{placement.price | formatMoney}}</span>
                    </div>
                    <!-- <div v-if="isUserCommercial || isSuperuser" class="icon-wrapper">
                      <i @click="editPrice(campaign.id, placement, idx)" class="icon-edit">
                      </i> 
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="line-wrapper">
              <hr class="line"/>
            </div>
            <div v-if="!lastData[campaign.id]" class="showMoreItem">
              <button @click="showMoreItem(campaign.id)" class="color-red">Show More</button>
            </div>
            <div v-else class="showMoreItem">
              <span class="color-grey">No more data</span >
            </div>
          </div>
          <div class="editQuotation__body__left__button" v-if="!isLoadingMain">
             <button class="btn-block secondary" @click="toggleModalNewCampaign()">Add More Campaign</button>
          </div>
        </div>
        </div>
        <div class="editQuotation__body__right">
          <div class="editQuotation__body__right__container">
            <h1 class="subhead title">Campaign Summary</h1>
            <!-- <div class="editQuotation__body__right__container__item">
              <span class="subhead"> Status </span>
              <label-status :progress="quotationStatus"/>
            </div> -->
            <div class="editQuotation__body__right__container__item">
              <span class="subhead">Selected Channel</span>
              <label>{{summary.selectedChannel}}</label>
            </div>
            <div class="editQuotation__body__right__container__item">
              <span class="subhead">Total Item</span>
              <label>{{summary.totalItem}}</label>
            </div>
            <div class="editQuotation__body__right__container__item">
              <span class="subhead">Campaign Start</span>
              <label>{{summary.campaignStartDate}}</label>
            </div>
            <div class="editQuotation__body__right__container__item">
              <span class="subhead">Campaign End</span>
              <label>{{summary.campaignEndDate}}</label>
            </div>
          </div>
          <div class="editQuotation__body__right__container">
            <div class="editQuotation__body__right__container__item">
              <span class="subhead"> Subtotal Price </span>
              <span class="subhead strong price color-pink"> {{model.totalPrice | formatMoney}}</span>
            </div>
          </div>
          <div class="editQuotation__body__right__button__top">
          <button class="btn-regular primary update" @click="updateQuotation('update')">
            Save
            <adx-loading-secondary-white class="circle-loading" v-if="isLoadingUpdate" />
          </button>
          <!-- <div>
            <button class=" approve btn-regular primary" @click="updateQuotation('approved')">Approve Quotation</button>
            <button class="btn-regular secondary" @click="updateQuotation('rejected')">Reject Quotation</button>
          </div> -->
          </div>
        </div>
      </div>
    </div>
  <!-- modal for remove campaign -->
  <adx-modal
    v-if="isShowModalRemove"
    @modal-close="toggleModalRemove"
    title="Remove Campaign?"
    type="small">
    <div slot="content" class="editQuotation__modal">
      <div class="editQuotation__modal__top">
        <div class="detail-item">
          there is two option to remove selected campaign, you can delete this campaign permanently or only remove this campaign from quotation and
          save as draft campaign.
          Note : If you select delete permanently you can undo this action.
        </div>
      </div>
      <div class="editQuotation__modal__bottom">
        <button :class="['btn-block secondary remove', isLoadingDelete ? 'disabled':'']" @click="deleteCampaign" :disabled="isLoadingDelete ? true : false">
          <span> Delete this campaign</span> 
          <adx-loading-secondary v-if="isLoadingDelete" />
        </button>
        <button :class="['btn-block primary remove', isLoadingUpdate ? 'disabled':'']" @click="updateQuotation('remove')" :disabled="isLoadingUpdate ? true : false">
          <span class="color-white">Remove and save to draft</span> 
          <adx-loading-secondary-white v-if="isLoadingUpdate" />
        </button>
      </div>
    </div>
  </adx-modal>
  <!-- modal for edit price -->
  <adx-modal
    v-if="isShowModal"
    @modal-close="toggleModal"
    title="Edit Price"
    type="small">
    <div slot="content" class="editQuotation__modal">
      <div class="editQuotation__modal__top">
        <div class="detail-item">
          <div class="detail-item__left">
            <div class="regular-font strong">{{selectedItem.line_item.name}}</div>
            <div class="subhead">{{selectedItem.line_item.location_data.name}}</div>
          </div>
          <div class="detail-item__right">
            <div class="subhead">{{'Given Price'}}</div>
            <div class="subhead color-pink strong" >{{selectedItem.price | formatMoney}}</div>
          </div>
        </div>
        <div class="price-item">
           <adx-input  :frontIcon="`rupiah`" :label="`Given Price`" :value.sync="itemPrice" :isThousandSeparator="true"/>
        </div>
      </div>
      <div class="editQuotation__modal__bottom">
        <button class="btn-block secondary" @click="toggleModal">Cancel</button>
        <button class="btn-block primary" @click="updateItemPrice(selectedItem.line_item.id) ">Save</button>
      </div>
    </div>
  </adx-modal>
  <!-- modal for edit campaign -->
   <adx-modal
    v-if="showModalCampaign"
    @modal-close="toggleModalNewCampaign"
    type="medium">
    <div slot="content" class="editQuotation__modal-add-campaign">
      <div class="editQuotation__modal-add-campaign__header">
        <div class="title"><h1 class="medium-title">Add Campaign</h1></div>
        <div><span class="mini-font">{{selectedNewCampaignIds.length}} New item added</span></div>
      </div>
      <div class="editQuotation__modal-add-campaign__search-filter">
        <div class="editQuotation__modal-add-campaign__search-filter__search">
          <i class="adx-ic_search"></i>
          <input v-model="searchBoxValue" type="text" placeholder="Search">
        </div>
        <div class="editQuotation__modal-add-campaign__search-filter__filter">
          <a-dropdown-list class="mediatype" @selected="selectedChannel" :valueDisplay="selectedChannelValue" 
          :list="channelList" :labelButton="`All Channels`" />
        </div>
      </div>
      <div class=editQuotation__modal-add-campaign__loading  v-if="isLoadingNewCampaign">
        <adx-loading/>
      </div>
      <div v-else-if="newCampaignList.length > 0" class="editQuotation__modal-add-campaign__content">
        <div v-for="(item, index) in newCampaignList" :key="index + '_item'" 
          class="editQuotation__modal-add-campaign__content__item">
            <div class="campaign-item">
              <div class="campaign-item__wrapper">
                <div class="campaign-item__wrapper__left">
                  <div class="campaign-item__wrapper__left__check-box">
                    <span :class="['selection-checkbox',selectedNewCampaignIds.includes(item.id) ? 'checked' : '']" 
                      @click.stop="toggleSelectCampaign(item)"><i class="icon-check"></i></span>
                    <adx-label-custom v-if="item.channel_name == 'outdoor'" :color="'#47d1af'" :label="'OUTDOOR'"/>
                    <adx-label-custom v-else-if="item.channel_name == 'lifestyle'" :color="'#5856d6'" :label="'LIFESTYLE'"/>
                    <adx-label-custom v-else-if="item.channel_name == 'airlines'" :color="'#b620e0'" :label="'AIRLINES'"/>
                    <adx-label-custom v-else :color="'#fa6400'" :label="'BUS ADVERTISING'"/>
                  </div>
                  <span class="item-name regular-font strong">{{item.name}}</span>
                  <span class="item-location color-grey subhead"> Date {{displayPeriod(item.start, item.end)}} • {{item.number_of_items}} Item
                  </span>
                </div>
                <div class="campaign-item__wrapper__right">
                  <div class="campaign-item__wrapper__right__price">
                    <span class="mini-font color-grey">Campaign Price</span>
                    <span class="subhead total-price color-pink strong">{{item.total_price | formatMoney}}</span>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div v-if="newCampaignList.length == 0 && !isLoadingNewCampaign" class="editQuotation__modal-add-campaign__empty-state">
        <adx-empty-selection :title="title"/>
      </div>
      <div class="editQuotation__modal-add-campaign__bottom">
        <button class="btn-block primary btn-update" :disabled="selectedNewCampaignIds.length == 0" @click="updateQuotation('add_new_campaign') ">
          Add Selected Campaign
          <span class="circle-loading"><adx-loading-2 v-if="isLoadingUpdate"/></span>
        </button>
      </div>
    </div>
  </adx-modal>
    <adx-modal
    v-if="isShowModalContinue"
    @modal-close="toggleModalContinue"
    title="Continue?"
    type="small">
    <div slot="content" class="editQuotation__modal">
      <div class="editQuotation__modal__top">
        <span class="sub-title subhead">Brand name has already saved on our list</span>
      </div>
      <div class="editQuotation__modal__bottom">
        <button class="btn-block primary continue-btn" @click="createOrUpdateClient('create')">Continue</button>
        <button class="btn-block secondary" @click="toggleModalContinue">Cancel</button>
      </div>
    </div>
  </adx-modal>
  </div>
</template>

<script>
import Loading from "@/components/Loading/Primary"
import LoadingSecondaryWhite from '@/components/Loading/Secondary-white'
import LoadingSecondary from '@/components/Loading/Secondary'
import Pagination from "@/components/Pagination"
import DropdownSort from "@/components/Form/SelectDropdown"
import ListDropdown from "@/components/Dropdown/ListDropdown"
import table from "@/components/Table"
import LabelStatus from "@/components/StatusLabel"
import LabelStatusCustom from '@/components/StatusLabelCustom'
import Discussions from '@/components/Discussions'

import api from "@/api"
import FileSaver from "file-saver"
import lib from "@/lib/util"
import { mapListFilter } from '@/lib/transformer'
import { apiV2 } from "@/api/urls"
import { parseErrorGql } from "@/lib/error"
import { helpers } from "@/lib/validation/"
import { mapGetters } from "vuex"
import { constants } from "crypto"
import { restEdge } from "@/api/edgeUrls"
import { globalMixins } from "@/lib/mixins/globalMixins";
import { ACheckbox, AInput, ATextArea, ASelectDropdown, AModal, ALoadingSecondary, AListDropdown,
        ALoadingSecondaryWhite, ASingleSearchDropdown, ALoadingPrimary, AEmptySelection} from "ui-kit-v1"
import { required, maxLength, minLength, email, alphaNum } from 'vuelidate/lib/validators'

const phone_validation = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[+]*(\([+0-9\s]*\)[\-\s]*)*[\-0-9\s]*$/.test(value)
}

export default {
  name: "adx-campaign-bus",
  components: {
    "adx-loading": Loading,
    "adx-loading-secondary-white": LoadingSecondaryWhite,
    "adx-loading-secondary": LoadingSecondary,
    "adx-pagination": Pagination,
    "adx-dropdown-sort": DropdownSort,
    "adx-dropdown-list": ListDropdown,
    "adx-textarea": ATextArea,
    "adx-empty-selection": AEmptySelection,
    "adx-table": table,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-input": AInput,
    "adx-select-dropdown": ASelectDropdown,
    "adx-modal": AModal,
    "adx-discussions": Discussions,
    "adx-loading-2": ALoadingSecondary,
    LabelStatus,
    "a-dropdown-list": AListDropdown,
    "adx-label-custom": LabelStatusCustom,
  },
  mixins: [globalMixins],
  props: {},
  data() {
    return {
      id: null,
      title: "You dont have any campaign here. lets create some !",
      isUserCs: true,
      isUserCommercial: false,
      isShowModal: false,
      isLoadingMain: false,
      isLoadingClient: false,
      isLoadingNewCampaign: false,
      isLoadingAddCampaign: false,
      loadingDetailClient: false,
      isClientLoading: false,
      showModalCampaign: false,
      isShowModalContinue: false,
      isDetailInfo: true,
      isLoadingForm: false,
      searchBoxValue: null,
      isShowModalRemove: false,
      campaignIndex: null,
      isLoadingUpdate: false,
      isLoadingDelete: false,
      selectedChannelValue: null,
      media_itemsKey:0,
      lastData: {},
      clientProfileList: [],
      brandList: [],
      model: {
        clientProfile: '',
        quotationName: null,
        note: null,
        status: null,
        totalPrice: 0,
        owner: null
      },
      clientProfileId : null,
      clientProfile: {
        // selected: '',
        companyName: null,
        brand: null,
        contactPerson: null,
        emailAdress: null,
        phoneNumber: null,
      },
      summary: {
        selectedChannel: 0,
        totalItem: 0,
        campaignStartDate: null,
        campaignEndDate: null
      },
      discussionList: [],
      campaign_list : [],
      campaign_medias: {},
      countPageItems: 4,
      newCampaignList: [],
      itemListTemp: [],
      selectedNewCampaignIds : [],
      quotationStatus:{
        value: null,
        label: null
      }, 
      mediaTypeId: null,
      selectedCampaign: null,
      selectedCampaignnIds: [],
      selectedItem: null,
      campaignId : null,
      itemPrice: 0,
      isLoading: true,
      item : null,
      channelList : [ 
        {
          "id" : 0,
          "label" : "All Channels",
          "value" : ''
        },
        {
          "id" : 1,
          "label" : "Airlines",
          "value" : 'airlines'
        },
        {
          "id" : 2,
          "label" : "Outdoor",
          "value" : 'outdoor'
        },
        {
          "id" : 3,
          "label" : "Lifestyle",
          "value" : 'lifestyle'
        },
        {
          "id" : 4,
          "label" : "Bus Advertising",
          "value" : 'bus'
        },
      ],
      vuelidateOptions: {
        quotationName: {
          field: 'quotation name',
          error: null,
          ref: 'quotationName'
        },
        clientProfile: {
          field: 'client profile ',
          error: null,
          ref: 'clientProfile'
        },
        // companyName: {
        //   field: 'company name',
        //   error: null,
        //   ref: 'companyName'
        // },
        // brand: {
        //   error: null,
        //   ref: 'brand'
        // },
        // contactPerson: {
        //   field: 'contact person',
        //   error: null,
        //   ref: 'contactPerson'
        // },
        // emailAdress: {
        //   field: 'email address',
        //   error: null,
        //   ref: 'emailAdress'
        // },
        // phoneNumber: {
        //   message: 'Please use valid phone number format',
        //   field: 'phone number',
        //   error: null,
        //   ref: 'phoneNumber'
        // },
      }
    }
  },
  validations: {
    model: {
      quotationName: { required, minLength: minLength(3), maxLength: maxLength(50) },
      clientProfile: {required}
      // companyName: { required },
      // brand: { required },
      // contactPerson: { required, minLength: minLength(3) }, 
      // emailAdress: { required, email},
      // phoneNumber: { required, phone_validation},
    },
  },
  computed: {
    ...mapGetters({
      token: "token",
      account: "account",
      isSuperuser: "isSuperuser"
    }),
    placementPrice() {
      let placement_price = this.itemPrice ? (parseInt(this.itemPrice.toString().split(".").join(""))) : 0
      return placement_price
    },
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.loadCampaignList()
    }, 500),
    selectedChannelValue: function() {
      this.$nextTick(() => {
        this.loadCampaignList()
      })
    },
    // itemPrice: function(){
    //   if (this.itemPrice < this.selectedItem.price ){
    //     this.showNotificationAlert('Error', 'given price can not lower than price!', 'danger')
    //   }
    // }
  },
  apollo: {

  },
  beforeCreate() {

  },
  async created() {
  
  },
  async beforeMount() {

  },
  async mounted() {
    this.id = this.$route.params.id
    this.isUserCs = this.account.groups == 'CS' || this.isSuperuser == true ? true : false
    this.isUserCommercial = this.account.groups == 'commercial' ? true : false 
    this.getDetailQuotation()
  },

  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {
    
  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async deleteCampaign(){
      this.isLoadingDelete = true
      const response = await api.destroy(restEdge.deleteDraftCampaignChannel(this.campaignId), {
        needToken: true, 
        useRestEdge: true,
      });
      
      if(response.status == 200) {
        this.campaign_list.splice(this.campaignIndex, 1)
        this.isLoadingDelete = false;
        this.showNotificationAlert('Success', 'Campaign successfully deleted!', 'success')
        this.toggleModalRemove();
      } else {
        this.isLoadingDelete = false;
        this.showNotificationAlert('Error', 'Campaign failed to delete!', 'danger')
      }
    },
    editCampaign(id){
      this.$router.push({name: 'campaigneditoredit', params:{id:id}})
    },
    removeCampaign(id, index){
      this.isShowModalRemove = true
      this.campaignId = id
      this.campaignIndex = index
    },
    async getDetailQuotation(){
      this.isLoadingMain = true
      const {data, status} = await api.get(restEdge.getOneQuotation(this.id), { 
        needToken: true, 
        useRestEdge: true 
      });

      if (status == 200) {
        this.mapData(data)
        this.getClientProfile(data)
        this.isLoadingMain = false
      } else {
        this.dangerAllert()
      }
    },
    mapData(data){
      //mapping quotation detail
      this.model.quotationName = data.name ? data.name : ''
      this.model.note = data.note ? data.note : '-'
      this.model.status = data.status
      this.model.owner = data.owner
      this.summary.selectedChannel = data.number_of_campaigns
      this.summary.campaignStartDate = this.displayDate(data.start)
      this.summary.campaignEndDate = this.displayDate(data.end)
      this.clientProfileId = data.client_profile

      //get total item
      let totalItem = []
      data.campaign_list.map( campaign =>{
        campaign.campaign_medias.map( media =>{
          media.line_item_list.map(line_item =>{
            totalItem.push(line_item)
          })
        })
      })
       this.summary.totalItem = totalItem.length

      //mapping item campaign and price
      if (data.campaign_list) {
        this.campaign_list = data.campaign_list
        data.campaign_list.map( campaign =>{
          let last = true
          let checkLast = false
          this.campaign_medias[campaign.id] = {
            'page': 1,
            'line_item_list': []
          }
          let added = 0

          for (let media of campaign.campaign_medias) {
            for (let item of media.line_item_list) {
              if (checkLast) {
                last = false
                break
              }
              this.campaign_medias[campaign.id].line_item_list.push({
                ...item,
                // 'media_type': media.media_type
              }
                ),
              added += 1
              if (added == this.countPageItems) checkLast = true
            }
             }
          if (last) {
            this.lastData[campaign.id] = true
          }
        })
      }

      if(this.campaign_list.length > 0){
        let subPrice = 0
        this.campaign_list.map( el =>{
          subPrice += el.total_price 
        }) 
        this.model.totalPrice = subPrice
      } 

      //status quotation
      let status = this.displayStatus(data.status)
      this.quotationStatus = {value : status.value, label: status.label}

      //mapping discussion
      if(data.discussion){
        data.discussion.map( el =>{

          let replies = []
          let discussionDate = new Date (el.created)

          //mapping replies into array as component require
          el.reply.map(data => {
            let dateReply = new Date(data.created)
            replies.push({
              'id'      : data.id,
              'label'   : 'username',
              'comment' : data.message,
              'date'    : dateReply
            })
          })

          this.discussionList.push({
            'id' : el.id,
            'label' : el.user, 
            'comment': el.message,
            'date' : discussionDate,
            'replies': replies
          })
        })
      }
    },
    async getClientProfile(response){
      this.isClientLoading = true
      const {data, status} = await api.get(restEdge.getClientProfile, { 
        needToken: true, 
        useRestEdge: true 
      });

      if (status == 200) {
        this.clientProfileList = mapListFilter({obj: data, id:`id`, value:`id`, label: `name`})
        this.brandList = data.map(data => data.brand)
        this.model.clientProfile = this.clientProfileList.filter( x => x.id == this.clientProfileId).pop()
        this.getDetailClientProfile()
      }else {
        this.dangerAllert()
      }
      this.isClientLoading = false
    },
    async getDetailClientProfile(){
      this.loadingDetailClient = true
      const {data, status} = await api.get(restEdge.getOneClientProfile(this.clientProfileId), { 
        needToken: true, 
        useRestEdge: true 
      });

      if (status == 200) {
        this.clientProfile.companyName = data.company_name ? data.company_name : '-',
        this.clientProfile.brand = data.brand ? data.brand : '-',
        this.clientProfile.contactPerson = data.contact_person ? data.contact_person : '-',
        this.clientProfile.emailAdress = data.email ? data.email : '-',
        this.clientProfile.phoneNumber = data.phone_number ? data.phone_number : '-'
      } else {
        this.dangerAllert()
      }
      this.loadingDetailClient = false
    },
    async createOrUpdateClient(param){
      this.isLoadingClient = true
      let body = {}
      body = {
        name : "name",
        company_name : this.clientProfile.companyName,
        contact_person : this.clientProfile.contactPerson,
        phone_number : this.clientProfile.phoneNumber,
        brand : this.clientProfile.brand,
        email : this.clientProfile.emailAdress
      }

      if (param == 'create'){
        const {data, status} = await api.post(restEdge.createClientProfile, body, { 
          needToken: true, 
          useRestEdge: true 
        });

        if (status == 200) {
          this.showNotificationAlert('Success', ' successfully create new client profile !', 'success')
          this.isLoadingClient = false
          this.getClientProfile()
        } else{
          this.dangerAllert()
        }
        this.isShowModalContinue = false
      } else {
        const {data, status} = await api.patch(restEdge.editClientProfile(this.clientProfileId), body, { 
          needToken: true, 
          useRestEdge: true 
        });

        if (status == 200) {
          this.showNotificationAlert('Success', ' successfully updated client profile !', 'success')
          this.isLoadingClient = false
          this.getDetailClientProfile()
        } else {
          this.dangerAlert()
        }
      }
    },
    changeClientProfile(params){
      this.clientProfileId = params.item.id
      this.getDetailClientProfile()
    },
    showMoreItem(campaign_id){
      let last = true
      let checkLast = false
      let page = this.campaign_medias[campaign_id].page + 1
      let campaign = this.campaign_list.filter(el => {
        return campaign_id === el.id
      })[0]
      let added = 0
      this.campaign_medias[campaign_id].page = page
      this.campaign_medias[campaign_id].media_items = []
      
      for (let media of campaign.campaign_medias) {
        for (let item of media.media_items) {
          if (checkLast) {
            last = false
            break
          }
          this.campaign_medias[campaign.id].media_items.push({
            ...item,
            'media_type': media.media_type
          })
          added += 1
          if (added == this.countPageItems * page) checkLast = true
        }
        this.campaign_medias[campaign.id].media_type.push(media.media_type)
      }

      this.media_itemsKey += 1
      if (last) {
        this.lastData[campaign_id] = true
      }
    },
    async updateQuotation(param){

      //calculating price from list campaign
      this.isLoadingUpdate = true
      let subPrice = 0 
      this.campaign_list.map( campaign =>{
        this.selectedCampaignnIds.push(campaign.id),
        subPrice += campaign.total_price
      })
      
      let body = {}
      this.isLoadingUpdate = true
      if (param == 'update') {
        this.$v.$touch()
        if (this.$v.model.$invalid) {
        this.vuelidateHelper(this.vuelidateOptions)
        this.isLoadingUpdate = false
        } else {
          body = { 
            name: this.model.quotationName,
            status: this.model.status,
            total_price: subPrice,
            campaigns_id: this.selectedCampaignnIds,
            client_profile: this.clientProfileId,
            owner: this.model.owner,
            note:  this.model.note
          }
          this.callApiUpdate(body, param)
        }
      } else if(param == 'approved') {
        body = { 
          status: param,
          campaigns_id: this.selectedCampaignnIds,
          total_price: subPrice,
          client_profile: this.clientProfileId,
        }
        this.callApiUpdate(body, param)
      } else if(param == 'add_new_campaign'){
        this.isLoadingAddCampaign = true
        body = { 
          campaigns_id: this.selectedNewCampaignIds,
          client_profile: this.clientProfileId,
          add_item: true
        }
        this.callApiUpdate(body, param)
      } else if(param == 'rejected'){
        body = { 
          status: param,
          campaigns_id: this.selectedCampaignnIds,
          total_price: subPrice,
          client_profile: this.clientProfileId,
        } 
        this.callApiUpdate(body, param)
      } else {
        const index = this.selectedCampaignnIds.indexOf(this.campaignId)
        body = { 
          campaigns_id: this.selectedCampaignnIds.splice(index, 1),
          client_profile: this.clientProfileId
        }
        this.callApiUpdate(body, param)
      }
    },
    async callApiUpdate(body, param){
      const {data, status} = await api.patch(restEdge.editQuotation(this.id), body, { 
        needToken: true, 
        useRestEdge: true 
      });
      if (status == 200){
        this.isLoadingUpdate = false
        if (param == 'remove') {
          this.showNotificationAlert('Success', 'campaign successfully remove!', 'success')
          this.campaign_list.splice(this.campaignIndex, 1)
          this.toggleModalRemove()
        }else if(param == 'add_new_campaign'){
          this.showNotificationAlert('Success', 'campaign successfully added!', 'success')
          this.toggleModalNewCampaign()
          this.getDetailQuotation()
          this.selectedTab(2)
        } else {
          this.showNotificationAlert('Success', 'Quotation successfully update!', 'success')
          this.goToQuotationList()
        }
      } else{
        this.isLoadingUpdate = false
        this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
      }
    },
    async updateItemPrice(id, mediaTypeId){
      if (this.itemPrice < this.selectedItem.price ){
        this.showNotificationAlert('Error', 'given price can not lower than price!', 'danger')
      }else {
        let body = {
          'item_id' : id,
          'price': this.placementPrice,
        }
        const {data, status} = await api.patch(restEdge.editItemPrice(this.campaignId), body, { 
          needToken: true, 
          useRestEdge: true 
        });

        if (status == 200){
          this.showNotificationAlert('Success', ' successfully updated !', 'success')
          this.itemPrice = 0
          this.getDetailQuotation()
          this.selectedTab(2)
          this.toggleModal()
        } else{
          this.dangerAllert()
        }
      }
    },
     async loadCampaignList(){
      this.isLoadingNewCampaign = true

      const response = await api.get(restEdge.draftCampaignChannel, { 
        needToken: true, 
        useRestEdge: true, 
        params:
          {
            search: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
            channel: this.selectedChannelValue
          }
      });

      if(response.status == 200){
        this.isLoadingNewCampaign = false
        const {data} = response
        this.newCampaignList = data
      } else {
        this.showNotificationAlert("Error", "Data failed to load!", "danger")
        this.issLoadingNewCampaign = false
        this.isEmpty = true
      }
    },
     toggleSelectCampaign(campaign){
      if (this.selectedNewCampaignIds.includes(campaign.id)) {
        // pop id when user unselected campaign item
        let index = this.selectedNewCampaignIds.indexOf(campaign.id)
        this.selectedNewCampaignIds.splice(index, 1)
      } else {
        this.selectedNewCampaignIds.push(campaign.id)
      }
    },
    submitDiscussion(){

    },
    dangerAlert(){
      this.showNotificationAlert('Error', 'Ops, something went wrong.', 'danger')
    },
    toggleModalNewCampaign(){
      this.showModalCampaign = !this.showModalCampaign
      this.selectedNewCampaignIds = []
      this.loadCampaignList()
    },
     displayDate(date){
      return date? `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', new Date(date))}`: '-'
    },
    editPrice(id, placement, index){
      this.isShowModal = true
      this.campaignId = id
      this.selectedItem = placement
    },
    goToQuotationList() {
       this.$router.push({ name: 'quotationlist'});
    },
    checkBrand(param){
      if (this.brandList.includes(this.clientProfile.brand)){
        this.isShowModalContinue = true
      }else{
        this.createOrUpdateClient('create')
      }
    },
    toggleModalContinue(){
      this.isShowModalContinue = !this.isShowModalContinue
    },
    toggleModalRemove(){
      this.isShowModalRemove = !this.isShowModalRemove
    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    selectedTab(item){
      this.isDetailInfo = (item==1)
    },
    selectedChannel(item){
      this.selectedChannelValue = item.value
    },
    displayPeriod(startDate, endDate) {
      if(startDate && endDate ){
        return `${lib.formatShortDate(startDate)} - ${lib.formatShortDate(endDate)}`
      }else{
        return `${lib.formatShortDate(startDate)}`
      }
    },
    displayStatus(status){
      let value = status.toLowerCase()
      let res = []
      switch(value){
        case `wfa`:
          res = { id: 0, value: 'pending', label: 'WAITING FOR APPROVAL'}
        case `approved`:
          res = { id: 0, value: 'done', label: 'APPROVED'}
          break
        case `rejected`:
          res = { id: 1, value: 'no', label: 'REJECTED'}
          break
      }
      return res
    },
    vuelidateHelper(vuelidateOptions){
      const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, vuelidateOptions, this.$refs)

      if (collection) {
        vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
      } else {
        vuelidateOptions[key].error = message
      }
      if (typeof element[0] == "undefined") {
        this.$nextTick(function() {
          element.scrollIntoView();
        });
      } else {
        this.$nextTick(function() {
          if (element[0].hasOwnProperty("$el")) {
            element[0].$el.scrollIntoView();
          } else {
            element[0].scrollIntoView();
          }
        });
      }
      this.saveLoading = false
    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
